import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/icon/exclamation@2x.png'
import _imports_1 from '@/assets/image/icon/circular_close.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "title-icon",
  draggable: false
}, null, -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "dialog-footer" }


import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  userData: {
    type: Object,
    default: () => {}
  },
  zIndex: {
    type: Number,
    default: 9900
  }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    width: "430px",
    "custom-class": "ObligationModal",
    "show-close": false,
    "close-on-click-modal": false,
    "z-index": __props.zIndex
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: _unref(useRtfix)('OrderList', { query: { platformOrderStatus: '2' } }),
          style: {"margin-left":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:visible', false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('去支付')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("h3", null, _toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("img", {
          src: _imports_1,
          class: "close-img",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false))),
          draggable: false
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('您有{num}笔订单待付款，请及时支付，否则会影响订单履约', { num: __props.userData.customerShop.waitPayOrderCount })), 1)
      ])
    ]),
    _: 1
  }, 8, ["model-value", "z-index"]))
}
}

})